/**
 * @fileoverview added by tsickle
 * Generated from: ragnarok-core/output/ragnarokprofiler.ts
 * @suppress {checkTypes,const,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode}
 */
goog.module('output.ragnarokprofiler');
var module = module || { id: 'ragnarokprofiler.ts' };
goog.require('tslib');
const tsickle_interfaces_1 = goog.requireType("output.interfaces");
const tsickle_rinterfaces_2 = goog.requireType("output.rinterfaces");
const tsickle_statsinterfaces_3 = goog.requireType("output.stats.statsinterfaces");
const tsickle_dependencies_4 = goog.requireType("output.dependencies");
const tsickle_telemetryhandler_5 = goog.requireType("output.telemetry.telemetryhandler");
const tsickle_nskinterfaces_6 = goog.requireType("output.nskinterfaces");
const dependencies_1 = goog.require('output.dependencies');
/** @type {string} */
const LOGTAG = "RProfiler";
/** @typedef {!output$ragnarokprofiler.Perf} */
exports.Perf;
/** @typedef {!output$ragnarokprofiler.ClientEvent} */
exports.ClientEvent;
/** @typedef {!output$ragnarokprofiler.WorkerInit} */
exports.WorkerInit;
/** @typedef {!output$ragnarokprofiler.StartStats} */
exports.StartStats;
/** @typedef {!output$ragnarokprofiler.StreamingQualityWithTs} */
exports.StreamingQualityWithTs;
/** @typedef {!output$ragnarokprofiler.StartWebSocket} */
exports.StartWebSocket;
/** @typedef {!output$ragnarokprofiler.MtbDuration} */
exports.MtbDuration;
/** @typedef {!output$ragnarokprofiler.InputChannelStats} */
exports.InputChannelStats;
/** @typedef {!output$ragnarokprofiler.GarbageCollectionStats} */
exports.GarbageCollectionStats;
/** @typedef {!output$ragnarokprofiler.WorkerMessage} */
exports.WorkerMessage;
// In retail builds, the build system will replace the value of this constant with the actual
// source code for the Ragnarok Worker.
// Use a template literal with embedded newline to start the preprocessor directive on a newline,
// and thus not have an indent - the preprocessor would otherwise replicate that indent after
// every newline in the source code, unnecessarily bulking the shipped product.
/** @type {string} */
const WORKER_SRC = `
var q={size:70,version:1,name:"DEPR"},r={size:80,version:3,name:"RTPV"},t={size:48,version:1,name:"RTPA"},aa={size:88,version:1,name:"TRAA"},ba={size:44,version:1,name:"TRAV"},ca={size:12,version:1,name:"VFMD"},da={size:20,version:1,name:"PFDA"},ea={size:0,version:1,name:""};function u(a,b=!1){try{let d;a.url.includes("wss")&&(d="x-nv-sessionid."+a.sessionId);let f=a.url;b&&(f+="&reconnect=1");let g=new WebSocket(f,d);g.onopen=()=>{a.h("{aaf44dc}");a.l.A();if(g===a.g){for(const c of a.j)c.stats?g.send(c.stats):g.send(JSON.stringify(c));for(const c of a.o)w(a,c);a.o=[]}};g.onclose=c=>{a.h("{7a09ad8}");a.l.v({error:a.u,code:c.code,reason:c.reason,wasClean:c.wasClean});g===a.g&&(a.g=void 0);a.u=!1};g.onerror=()=>{a.h("{418a180}");a.u=!0};g.onmessage=c=>{c=JSON.parse(c.data);
a.serverSupportsAck&&x(a);void 0===c.ackid||a.serverSupportsAck||(a.serverSupportsAck=!0,a.h("{523f5b9}"),x(a));if(!c.hb)if(a.serverSupportsAck){if(void 0!==c.ack){var e=c.ack;for(let k=a.j.length-1;0<=k;k--)a.j[k].ackid<=e&&a.j.splice(k,1)}void 0!==c.ackid?(a.maxReceivedAckId<c.ackid&&(a.l.s(c),a.maxReceivedAckId=c.ackid),a.g&&(c=JSON.stringify({ack:a.maxReceivedAckId}),a.h("{903be10}"+c),a.g.send(c))):void 0===c.ack&&a.l.s(c)}else a.l.s(c)};a.g=g}catch(d){a.g=void 0,a.B("WebSocket creation exception: "+
d)}}function y(a){0!==a.m&&(self.clearTimeout(a.m),a.m=0)}function x(a){y(a);a.m=self.setTimeout(()=>{var b;a.h("{6c3505a}"+(null===(b=a.g)||void 0===b?void 0:b.readyState));a.g||u(a,!0);x(a)},3E3)}function w(a,b){void 0!==b.ackid&&a.serverSupportsAck&&void 0!==b.ackid&&a.j.push(b);a.g&&(b.stats?a.g.send(b.stats):a.g.send(JSON.stringify(b)))}
var ja=class{constructor(){var a={s:fa,A:ha,v:ia,C:z},b=A,d=B;this.sessionId=C;this.serverSupportsAck=this.u=!1;this.j=[];this.o=[];this.maxReceivedAckId=this.m=0;this.url="";this.h=b;this.B=d;this.l=a}initialize(a,b,d,f=!1){this.url=a;this.maxReceivedAckId=b;this.serverSupportsAck=d;u(this,f);this.h("{f4b05a4}")}uninitialize(a){var b;this.maxReceivedAckId=0;this.serverSupportsAck=!1;this.j=[];this.o=[];y(this);null===(b=this.g)||void 0===b?void 0:b.close(a);this.h("{986b258}"+a)}reconnect(){u(this,
!0)}send(a){this.serverSupportsAck||this.g||u(this,!0);this.g&&this.g.readyState===WebSocket.OPEN?w(this,a):this.o.push(a)}};const D=self;let F=[],G=[];function H(a){a.h&&(a.j("{890d3ae}"+a.h),a.h=0);a.g.clear()}function ka(a){var b=K;let d=b.g.get(a.type);d||(d=[],b.g.set(a.type,d));for(const f of a.stats)d.push(f)}function la(a){switch(a){case 0:return q;case 1:return r;case 2:return t;case 3:return ba;case 4:return aa;case 5:return ca;case 6:return da;default:return ea}}
let K=new class{constructor(a){this.j=a;this.g=new Map;this.h=0;H(this)}size(){let a=0;for(let [,b]of this.g){let d=b;for(let f of d)a+=f.byteLength}return a+=9*this.g.size}write(a,b){var d=b;for(let [k,l]of this.g){b=k;var f=l,g=d,c=d;d=f.length;var e=la(b);let m=e.name,p=new DataView(a.buffer);for(let h=0;4>h;h++)p.setUint8(c+h,m.charCodeAt(h));p.setUint8(c+4,e.version);p.setUint16(c+5,d,!0);p.setUint16(c+7,e.size,!0);g=d=g+9;c=a;e=0;for(let h of f)f=new Uint8Array(h),c.set(f,d+e),e+=h.byteLength;
d=g+e;1===b&&this.h++}return d}}(A),C="",L="",M=null,N=void 0,O=0,P=[],Q=[],R=[],S=[],T=[],U=!1,V=0;function A(a){D.postMessage({log:a})}function B(a){D.postMessage({exception:a})}function W(){F=[];G=[];H(K);P=[];Q=[];R=[];S=[];T=[]}function X(a,b,d,f,g,c){for(let e=0;4>e;e++)a.setUint8(b+e,d.charCodeAt(e));a.setUint8(b+4,f);a.setUint16(b+5,g,!0);a.setUint16(b+7,c,!0)}function Y(a){return 0>a?Math.max(a,-2147483648):Math.min(a,4294967295)}
function Z(){if((F.length||G.length||K.size())&&M)try{M.ackid=U?V:void 0;var a=JSON.stringify(M),b=a.length,d=b+2,f=new ArrayBuffer(d);const E=new DataView(f);E.setUint16(0,b);for(b=2;b<d;++b)E.setUint8(b,a.charCodeAt(b-2));var g=new Uint8Array(f),c=13*F.length,e=72*G.length,k=12*P.length,l=10*Q.length,m=12*R.length,p=16*S.length;const I=8*T.length;let v=9+g.length;c&&(v+=9+c);e&&(v+=9+e);k&&(v+=9+k);l&&(v+=9+l);m&&(v+=9+m);p&&(v+=9+p);I&&(v+=9+I);v+=K.size();const J=new ArrayBuffer(v);var h=new DataView(J);
a=0;(new Uint8Array(J)).set(g);a+=g.length;X(h,a,"BPRF",1,0,0);a+=9;if(c){X(h,a,"PERF",2,F.length,13);a+=9;g=h;d=a;for(f=0;f<F.length;f++)g.setFloat64(d,F[f].RAFTS,!0),g.setUint16(d+8,Math.min(1E3*F[f].DCSend,65535),!0),g.setUint16(d+10,Math.min(1E3*F[f].GetStats,65535),!0),g.setUint8(d+12,F[f].FrameInfo),d+=13;a+=c}if(e){X(h,a,"EVNT",1,G.length,72);a+=9;c=h;g=a;for(d=0;d<G.length;d++){c.setFloat64(g,G[d].TS,!0);g+=8;var n=G[d].eventtype;for(f=0;f<n.length&&63>f;f++)c.setUint8(g+f,n.charCodeAt(f));
c.setUint8(g+f,0);g+=64}a+=e}if(k){X(h,a,"SQEV",1,P.length,12);a+=9;e=h;n=a;for(c=0;c<P.length;c++)e.setUint8(n,P[c].qualityScore),e.setUint8(n+1,P[c].bandwidthScore),e.setUint8(n+2,P[c].latencyScore),e.setUint8(n+3,P[c].networkLossScore),e.setFloat64(n+4,P[c].timestamp,!0),n+=12;a+=k}if(l){X(h,a,"MTBD",1,Q.length,10);a+=9;k=h;e=a;for(n=0;n<Q.length;n++)k.setFloat64(e,Q[n].timestamp,!0),k.setUint16(e+8,Math.min(Q[n].duration,65535),!0),e+=10;a+=l}if(m){X(h,a,"INPT",1,R.length,12);a+=9;l=h;k=a;for(e=
0;e<R.length;e++)l.setFloat64(k,R[e].timestamp,!0),l.setUint16(k+8,Math.min(R[e].bufferedAmount,65535),!0),l.setUint16(k+10,Math.min(R[e].maxSchedulingDelay,65535),!0),k+=12;a+=m}if(p){X(h,a,"GRBG",1,S.length,16);a+=9;m=h;l=a;for(k=0;k<S.length;k++)m.setFloat64(l,S[k].timestamp,!0),m.setInt32(l+8,Y(S[k].deltaUsedHeapSize),!0),m.setInt32(l+12,Y(S[k].deltaTotalHeapSize),!0),l+=16;a+=p}if(I){X(h,a,"MKPT",1,T.length,8);a+=9;p=h;h=a;for(m=0;m<T.length;m++)p.setFloat64(h,T[m],!0),h+=8;a+=I}let ma=new Uint8Array(J);
K.write(ma,a);null===N||void 0===N?void 0:N.send({stats:J,ackid:U?V:void 0})}catch(E){B("Exception in perf/stats upload. Error : "+E.message+" stack: "+E.stack)}W()}function fa(a){U||void 0===a.ackid||(U=!0);D.postMessage({wsMessage:a})}function ia(a){D.postMessage({wsClose:a})}function ha(){D.postMessage({wsOpen:!0})}function z(){D.postMessage({wsOpening:!0})}function na(a,b){N=new ja;N.initialize(L,a,U,b);z()}
D.onmessage=function(a){try{const b=a.data;b.initMessage?(C=b.initMessage.sessionId,D.postMessage({initialized:!0})):b.perf?F.push(b.perf):b.clientEvent?G.push(b.clientEvent):b.startStats?(M=b.startStats.statsHeader,O=self.setInterval(()=>Z(),5E3),D.postMessage({statsStarted:!0}),A("{5209d98}")):b.stopStats?(self.clearInterval(O),Z(),W(),A("{b58b6ad}")):b.webrtcStats?(b.ackid&&(V=b.ackid),b.webrtcStats.stats&&ka(b.webrtcStats)):b.sq?P.push(b.sq):b.startWebSocket?(L=b.startWebSocket.signInURL,U=b.startWebSocket.serverSupportsAck,
na(b.startWebSocket.maxReceivedAckId,b.startWebSocket.reconnect)):b.stopWebSocket?(null===N||void 0===N?void 0:N.uninitialize(),U=!1):b.send?null===N||void 0===N?void 0:N.send(b.send):b.duration?Q.push(b.duration):b.inputChannelStats?R.push(b.inputChannelStats):b.garbageCollectionStats?S.push(b.garbageCollectionStats):b.qosMarker&&T.push(b.qosMarker)}catch(b){B("Worker onmessage exception: "+b)}};


`;
/* Messages for the main thread *(/

/* This class creates a worker thread and controls it through the life time of the webpage.
   The worker thread is not terminated and is removed by browser during page unload.
   Between every stream session the worker is asked to do background work and is stopped at the
   end of the stream session. */
class RagnarokProfilerImpl {
    /**
     * @public
     */
    constructor() {
        this.profiling = false;
        this.rworker = null;
        this.streamBeginTs = 0;
        this.wsHandler = null;
        this.pendingErrors = [];
        this.pendingTelemetry = [];
        this.workerInitialized = false;
        this.perf = {
            RAFTS: 0,
            DCSend: 0,
            GetStats: 0,
            FrameInfo: 0
        };
        /*@todo: Logging to console directly. At this point Logger class is not initialized and
                  it doesnt even log to console if eventEmitter is not set. Figure out how to set to redesign
                  eventEmitter so that all logs during initialization is collected */
        dependencies_1.Log.i("{1f5ec29}", "{139da36}");
        try {
            /** @type {string} */
            let blobContent;
            // If WORKER_SRC's content is replaced by the build system, it'll be larger than the
            // preprocessor directive (which has current length of 40 characters).
            if (WORKER_SRC.length > 40) {
                blobContent = WORKER_SRC;
            }
            else {
                /** @type {string} */
                let workerFile = "";
                /** @type {(null|!HTMLScriptElement)} */
                const currentScript = (/** @type {(null|!HTMLScriptElement)} */ (document.currentScript));
                if (currentScript) {
                    // use absolute path for worker, in case page and scripts are in different locations
                    /** @type {number} */
                    const pathEnd = currentScript.src.lastIndexOf("/");
                    if (pathEnd !== -1) {
                        workerFile += currentScript.src.substring(0, pathEnd + 1);
                    }
                }
                workerFile += "ragnarokworker.js";
                // use import scripts and blob URL to allow cross origin loading of worker
                blobContent = "importScripts('" + workerFile + "');";
            }
            /** @type {!Blob} */
            const blob = new Blob([blobContent], { type: "text/javascript" });
            /** @type {string} */
            const blobUrl = URL.createObjectURL(blob);
            this.rworker = new Worker(blobUrl);
            URL.revokeObjectURL(blobUrl);
            this.rworker.onmessage = this.onWorkerMessage.bind(this);
            this.rworker.onerror = this.onWorkerError.bind(this);
            dependencies_1.Log.i("{1f5ec29}", "{62dee75}");
        }
        catch (err) {
            dependencies_1.Log.e("{1f5ec29}", "{50fa2e5}", err.message);
            this.pendingTelemetry.push({
                name: "RagnarokWorkerProblem",
                error: JSON.stringify(err)
            });
        }
    }
    /**
     * @public
     * @param {string} signInURL
     * @param {number} maxReceivedAckId
     * @param {boolean} serverSupportsAck
     * @param {!tsickle_rinterfaces_2.WebSocketHandler} wsHandler
     * @param {(undefined|boolean)=} reconnect
     * @return {void}
     */
    startWebSocket(signInURL, maxReceivedAckId, serverSupportsAck, wsHandler, reconnect) {
        this.wsHandler = wsHandler;
        /** @type {!output$ragnarokprofiler.WorkerMessage} */
        let msg = {
            startWebSocket: {
                signInURL,
                maxReceivedAckId,
                serverSupportsAck,
                reconnect
            }
        };
        if (this.rworker) {
            this.rworker.postMessage(msg);
            dependencies_1.Log.d("{1f5ec29}", "{b3f6faa}");
        }
    }
    /**
     * @public
     * @return {void}
     */
    stopWebSocket() {
        /** @type {!output$ragnarokprofiler.WorkerMessage} */
        const workerMessage = {
            stopWebSocket: true
        };
        if (this.rworker) {
            dependencies_1.Log.d("{1f5ec29}", "{7ac815d}");
            this.rworker.postMessage(workerMessage);
        }
        this.wsHandler = null;
    }
    /**
     * @public
     * @param {string} sessionId
     * @param {!tsickle_telemetryhandler_5.TelemetryHandler} telemetry
     * @param {!tsickle_rinterfaces_2.AckIdGenerator} ackIdGenerator
     * @return {void}
     */
    initialize(sessionId, telemetry, ackIdGenerator) {
        this.telemetry = telemetry;
        this.ackIdGenerator = ackIdGenerator;
        if (this.pendingTelemetry.length > 0) {
            for (const obj of this.pendingTelemetry) {
                telemetry.emitDebugEvent(obj.name, obj.error);
            }
            this.pendingTelemetry = [];
        }
        if (this.pendingErrors.length > 0) {
            for (const error of this.pendingErrors) {
                this.emitError(error);
            }
            this.pendingErrors = [];
        }
        this.profiling = false;
        this.resetPerf();
        // If needed, updateStreamTime should be called with a better stream begin time.
        if (this.streamBeginTs === 0) {
            this.updateStreamTime();
        }
        if (this.rworker) {
            /** @type {!output$ragnarokprofiler.WorkerMessage} */
            const workerMessage = {
                initMessage: {
                    sessionId
                }
            };
            this.rworker.postMessage(workerMessage);
            dependencies_1.Log.d("{1f5ec29}", "{404f264}");
        }
        else {
            dependencies_1.Log.e("{1f5ec29}", "{c62bf29}");
        }
    }
    /**
     * @public
     * @return {void}
     */
    deinitialize() {
        var _a;
        if (!this.workerInitialized) {
            (_a = this.telemetry) === null || _a === void 0 ? void 0 : _a.emitDebugEvent("Worker Thread Creation Failed");
        }
        this.telemetry = undefined;
    }
    /**
     * @public
     * @param {!tsickle_rinterfaces_2.StatsHeader} statsHeader
     * @return {void}
     */
    startProfiling(statsHeader) {
        this.profiling = false;
        /** @type {!output$ragnarokprofiler.WorkerMessage} */
        const workerMessage = {
            startStats: {
                statsHeader
            }
        };
        if (this.rworker) {
            dependencies_1.Log.d("{1f5ec29}", "{6897d5e}");
            this.rworker.postMessage(workerMessage);
        }
    }
    /**
     * @public
     * @return {void}
     */
    stopProfiling() {
        this.profiling = false;
        /** @type {!output$ragnarokprofiler.WorkerMessage} */
        const workerMessage = {
            stopStats: true
        };
        if (this.rworker) {
            dependencies_1.Log.d("{1f5ec29}", "{76b05dd}");
            this.rworker.postMessage(workerMessage);
        }
    }
    /**
     * @public
     * @return {void}
     */
    updateStreamTime() {
        // Every timestamp collected and uploaded to server will be relative to below timestamp.
        this.streamBeginTs = performance.now();
    }
    /**
     * @public
     * @return {void}
     */
    resetPerf() {
        this.perf.RAFTS = 0;
        this.perf.DCSend = 0;
        this.perf.GetStats = 0;
        this.perf.FrameInfo = 0;
    }
    /**
     * @public
     * @param {!tsickle_rinterfaces_2.WebSocketMsg} _send
     * @return {void}
     */
    sendOverWs(_send) {
        if (this.rworker) {
            /** @type {!output$ragnarokprofiler.WorkerMessage} */
            let msg = {
                send: _send
            };
            this.rworker.postMessage(msg);
        }
    }
    /**
     * @public
     * @param {!MessageEvent<?>} ev
     * @return {void}
     */
    onWorkerMessage(ev) {
        /** @type {!tsickle_rinterfaces_2.WorkerResponse} */
        let response = ev.data;
        if (response.initialized) {
            dependencies_1.Log.i("{1f5ec29}", "{6ccab8d}");
            this.workerInitialized = true;
        }
        else if (response.statsStarted) {
            this.profiling = true;
            dependencies_1.Log.d("{1f5ec29}", "{e98d45f}");
        }
        else if (response.log) {
            dependencies_1.Log.i("{cbf9f59}", "{0b0c6f9}", response.log);
        }
        else if (response.exception) {
            dependencies_1.Log.i("{cbf9f59}", "{0b0c6f9}", response.exception);
        }
        else if (response.wsClose) {
            if (this.wsHandler) {
                this.wsHandler.closeHandler(response.wsClose);
            }
            else {
                dependencies_1.Log.e("{1f5ec29}", "{900a6f2}");
            }
        }
        else if (response.wsMessage) {
            if (this.wsHandler) {
                this.wsHandler.messageHandler(response.wsMessage);
            }
            else {
                dependencies_1.Log.e("{1f5ec29}", "{900a6f2}");
            }
        }
        else if (response.wsOpening) {
            if (this.wsHandler) {
                this.wsHandler.openingHandler();
            }
            else {
                dependencies_1.Log.e("{1f5ec29}", "{900a6f2}");
            }
        }
        else if (response.wsOpen) {
            if (this.wsHandler) {
                this.wsHandler.openHandler();
            }
            else {
                dependencies_1.Log.e("{1f5ec29}", "{900a6f2}");
            }
        }
    }
    /**
     * @private
     * @param {!ErrorEvent} ev
     * @return {void}
     */
    onWorkerError(ev) {
        if (this.telemetry) {
            this.emitError(ev);
        }
        else {
            this.pendingErrors.push(ev);
        }
    }
    /**
     * @private
     * @param {!ErrorEvent} ev
     * @return {void}
     */
    emitError(ev) {
        var _a, _b, _c, _d;
        // We are seeing that the ErrorEvent object doesn't contain any useful
        // information. Fill defaults to avoid parsing errors.
        (/** @type {!tsickle_telemetryhandler_5.TelemetryHandler} */ (this.telemetry)).emitExceptionEvent(undefined, (_a = ev === null || ev === void 0 ? void 0 : ev.message) !== null && _a !== void 0 ? _a : "", (_b = ev === null || ev === void 0 ? void 0 : ev.filename) !== null && _b !== void 0 ? _b : "", (_c = ev === null || ev === void 0 ? void 0 : ev.lineno) !== null && _c !== void 0 ? _c : 0, (_d = ev === null || ev === void 0 ? void 0 : ev.colno) !== null && _d !== void 0 ? _d : 0, true, "WorkerError");
    }
    /**
     * @public
     * @return {void}
     */
    onPreRender() {
        if (this.profiling) {
            if (this.perf.RAFTS != 0) {
                /** @type {!output$ragnarokprofiler.WorkerMessage} */
                const workerMessage = {
                    perf: this.perf
                };
                if (this.rworker) {
                    this.rworker.postMessage(workerMessage);
                }
                this.resetPerf();
            }
            this.perf.RAFTS = this.getStreamTime();
        }
    }
    /**
     * @public
     * @param {number} _time
     * @return {void}
     */
    addDataChannelSendTime(_time) {
        if (this.profiling) {
            this.perf.DCSend += _time;
        }
    }
    /**
     * @public
     * @param {number} _time
     * @return {void}
     */
    addGetStatsTime(_time) {
        if (this.profiling) {
            this.perf.GetStats += _time;
        }
    }
    /**
     * @public
     * @param {!Array<!ArrayBuffer>} report
     * @param {tsickle_statsinterfaces_3.StatsType} type
     * @return {void}
     */
    addStatsReport(report, type) {
        var _a;
        if (this.profiling) {
            /** @type {!output$ragnarokprofiler.WorkerMessage} */
            const workerMessage = {
                webrtcStats: { type: type, stats: report },
                ackid: (_a = this.ackIdGenerator) === null || _a === void 0 ? void 0 : _a.getNextAckId()
            };
            if (this.rworker) {
                //   console.log("report to  " + typeof report);
                this.rworker.postMessage(workerMessage, report);
            }
        }
    }
    /**
     * @public
     * @param {!tsickle_nskinterfaces_6.StreamQuality} streamingQuality
     * @return {void}
     */
    addQualityScore(streamingQuality) {
        if (this.profiling) {
            /** @type {!output$ragnarokprofiler.WorkerMessage} */
            const workerMessage = {
                sq: {
                    latencyScore: streamingQuality.latencyScore,
                    bandwidthScore: streamingQuality.bandwidthScore,
                    qualityScore: streamingQuality.qualityScore,
                    networkLossScore: streamingQuality.networkLossScore,
                    timestamp: this.getStreamTime()
                }
            };
            if (this.rworker) {
                this.rworker.postMessage(workerMessage);
            }
        }
    }
    /**
     * @public
     * @param {number} duration
     * @param {number} startTime
     * @return {void}
     */
    addMainThreadBlockDuration(duration, startTime) {
        if (this.profiling) {
            /** @type {!output$ragnarokprofiler.WorkerMessage} */
            const workerMessage = {
                duration: {
                    timestamp: startTime - this.streamBeginTs,
                    duration: duration
                }
            };
            if (this.rworker) {
                this.rworker.postMessage(workerMessage);
            }
        }
    }
    /**
     * @public
     * @param {number} bufferedAmount
     * @param {number} schedulingDelay
     * @return {void}
     */
    addInputChannelStats(bufferedAmount, schedulingDelay) {
        if (this.profiling) {
            /** @type {!output$ragnarokprofiler.WorkerMessage} */
            const workerMessage = {
                inputChannelStats: {
                    timestamp: this.getStreamTime(),
                    bufferedAmount: bufferedAmount,
                    maxSchedulingDelay: schedulingDelay
                }
            };
            if (this.rworker) {
                this.rworker.postMessage(workerMessage);
            }
        }
    }
    /**
     * @public
     * @param {number} deltaUsedHeapSize
     * @param {number} deltaTotalHeapSize
     * @return {void}
     */
    addGarbageCollectionStats(deltaUsedHeapSize, deltaTotalHeapSize) {
        if (this.profiling) {
            /** @type {!output$ragnarokprofiler.WorkerMessage} */
            const workerMessage = {
                garbageCollectionStats: {
                    timestamp: this.getStreamTime(),
                    deltaUsedHeapSize: deltaUsedHeapSize,
                    deltaTotalHeapSize: deltaTotalHeapSize
                }
            };
            if (this.rworker) {
                this.rworker.postMessage(workerMessage);
            }
        }
    }
    /**
     * @public
     * @return {void}
     */
    addQosMarker() {
        if (this.profiling) {
            /** @type {!output$ragnarokprofiler.WorkerMessage} */
            const workerMessage = {
                qosMarker: this.getStreamTime()
            };
            if (this.rworker) {
                this.rworker.postMessage(workerMessage);
            }
        }
    }
    /**
     * @public
     * @param {number} framesDecoded
     * @param {number} framesDropped
     * @return {void}
     */
    onFrameInfo(framesDecoded, framesDropped) {
        if (this.profiling) {
            /* Frame Render Info of the video tag element.
                           This is not related to decode.
                           1 byte value:  Upper nibble - FramesDecoded
                                          Lower nibble - FramesDropped.
                           In case either framesDecoded/Dropped is above 15,
                           upload 15(0xF) as the value so that its contained in nibble*/
            /** @type {number} */
            let x = Math.min(framesDecoded, 15) << 4;
            /** @type {number} */
            let y = Math.min(framesDropped, 15);
            this.perf.FrameInfo = x | y;
        }
    }
    /**
     * @public
     * @param {string} type
     * @return {void}
     */
    onEvent(type) {
        if (this.profiling) {
            /** @type {!output$ragnarokprofiler.WorkerMessage} */
            const workerMessage = {
                clientEvent: {
                    TS: this.getStreamTime(),
                    eventtype: type
                }
            };
            if (this.rworker) {
                this.rworker.postMessage(workerMessage);
            }
        }
    }
    /* Get the current time relative to the stream start time. */
    /**
     * @public
     * @return {number}
     */
    getStreamTime() {
        return performance.now() - this.streamBeginTs;
    }
    /**
     * @public
     * @return {number}
     */
    getStreamBeginTime() {
        return this.streamBeginTs;
    }
}
exports.RagnarokProfilerImpl = RagnarokProfilerImpl;
/* istanbul ignore if */
if (false) {
    /**
     * @type {boolean}
     * @private
     */
    RagnarokProfilerImpl.prototype.profiling;
    /**
     * @type {!output$ragnarokprofiler.Perf}
     * @private
     */
    RagnarokProfilerImpl.prototype.perf;
    /**
     * @type {(null|!Worker)}
     * @private
     */
    RagnarokProfilerImpl.prototype.rworker;
    /**
     * @type {number}
     * @private
     */
    RagnarokProfilerImpl.prototype.streamBeginTs;
    /**
     * @type {(null|!tsickle_rinterfaces_2.WebSocketHandler)}
     * @private
     */
    RagnarokProfilerImpl.prototype.wsHandler;
    /**
     * @type {(undefined|!tsickle_telemetryhandler_5.TelemetryHandler)}
     * @private
     */
    RagnarokProfilerImpl.prototype.telemetry;
    /**
     * @type {(undefined|!tsickle_rinterfaces_2.AckIdGenerator)}
     * @private
     */
    RagnarokProfilerImpl.prototype.ackIdGenerator;
    /**
     * @type {!Array<!ErrorEvent>}
     * @private
     */
    RagnarokProfilerImpl.prototype.pendingErrors;
    /**
     * @type {!Array<{name: string, error: string}>}
     * @private
     */
    RagnarokProfilerImpl.prototype.pendingTelemetry;
    /**
     * @type {boolean}
     * @private
     */
    RagnarokProfilerImpl.prototype.workerInitialized;
}
// Create one instance of profiler used by all Ragnarok classes.
/** @type {!RagnarokProfilerImpl} */
exports.RagnarokProfiler = new RagnarokProfilerImpl();
